import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { useEntitlements } from '../subscription/offers';
import { stopSpeaking } from '../games/speak';
import TalkBoardPage from './TalkBoardPage';
import { onTalkOpen, setTalkBoardOpen, useGameBarShown } from './talkOpen';
import { useT } from '../i18n/i18n';

export default function TalkLauncher() {
  const { token } = useAuth();
  const t = useT();
  const entitlements = useEntitlements(!!token);
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const closeRef = useRef<HTMLButtonElement | null>(null);
  const openerRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (!open) return;
    stopSpeaking();
    closeRef.current?.focus();
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('keydown', onKey);
      openerRef.current?.focus();
    };
  }, [open]);

  useEffect(() => { setOpen(false); }, [pathname]);
  useEffect(() => { setTalkBoardOpen(open); }, [open]);
  useEffect(() => () => setTalkBoardOpen(false), []);
  useEffect(() => onTalkOpen(() => setOpen(true)), []);
  const inGame = useGameBarShown();

  if (!token || !entitlements?.talkBoard || pathname === '/talk') return null;

  return (
    <>
      {!inGame && <button
        ref={openerRef}
        type="button"
        className="tb-launcher"
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={() => setOpen(true)}
      >
        <span aria-hidden="true">💬</span>
        <span>{t('Talk')}</span>
      </button>}
      {open && (
        <div className="tb-overlay" role="dialog" aria-modal="true" aria-label={t('Talk Board')}>
          <div className="tb-overlay-bar">
            <strong>{t('Talk Board')}</strong>
            <button ref={closeRef} type="button" className="btn secondary" onClick={() => setOpen(false)}>{t('Close')}</button>
          </div>
          <div className="tb-overlay-body">
            <TalkBoardPage />
          </div>
        </div>
      )}
    </>
  );
}
